/* Publish by EComposer at 2024-07-15 19:24:53*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-vl0wiw3fwfb"]=  window.__ectimmers["ecom-vl0wiw3fwfb"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(i&&i.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-vl0wiw3fwfb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vl0wiw3fwfb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-azztpxlffzm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-azztpxlffzm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qtkvwyk55s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qtkvwyk55s', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-443wwy9b0m4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-443wwy9b0m4', settings: {},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}